import * as React from 'react';
import { mergeStyles } from '@fluentui/react';
import { gridSubUnit } from '@uifabric/portal-ux/lib/styling/stylingConstants';

export interface IContactPreferenceContentProps {
  children?: React.ReactNode;
}

export const ContactPreferenceContent = ({ children }: IContactPreferenceContentProps): React.ReactElement => {
  const className = mergeStyles({
    displayName: 'ContactPreferenceContent',
    margin: `${gridSubUnit * 5}px`,
  });

  return <div className={className}>{children}</div>;
};
